import i18next from 'i18next';
import { z } from 'zod';

export const newTimetableSchema = (existingNames: string[]) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, i18next.t('validation.timetableDraft.nameRequired'))
      .refine((name) => !existingNames.includes(name), i18next.t('validation.timetableDraft.nameUnique')),
    comment: z.string(),
    timeGridUuid: z.string().min(1, i18next.t('validation.timetableDraft.timegridConfig.timegridRequired')),
  });

export type NewTimetableFormType = z.infer<ReturnType<typeof newTimetableSchema>>;
